<script>
  import { onMount } from "svelte";

  import { SvelteToast, toast } from "@zerodevx/svelte-toast";

  import TailwindCss from "./Tailwind.svelte";
  let data = {};
  onMount(() => {
    fetch("/data.json")
      .then((d) => d.json())
      .then((d) => (data = d));
    toast.push("Loaded Students!", {
      theme: {
        "--toastColor": "mintcream",
        "--toastBackground": "rgba(72,187,120,0.9)",
        "--toastBarBackground": "#2F855A",
      },
      duration: 1000,
    });
  });

  let studs = [];
  let prn;
  const onSub = (e) => {
    e.preventDefault();

    const prnStudent = data[prn.value];
    if (!prnStudent) {
      toast.push("Student not found " + prn.value + "!", {
        theme: {
          // Yellow theme
          "--toastColor": "white",
          "--toastBackground": "#cc0000",
          "--toastBarBackground": "#2F855A",
        },
        duration: 2000,
      });
      prn.value = "";
      return;
    }

    studs = [...studs, prn.value];
    studs = [...new Set(studs)];
    console.log(studs);
    toast.push("Added " + prn.value, {
      theme: {
        "--toastColor": "mintcream",
        "--toastBackground": "rgba(72,187,120,0.9)",
        "--toastBarBackground": "#2F855A",
      },
      duration: 1000,
    });
    prn.value = "";
    prn.focus();
  };

  const jsonToCsv = () => {
    const headers = ["PRN", "Name", "Roll No."];
    const rows = studs.map((s) => [s, data[s].name, data[s].roll_no]);
    let csvContent =
      "data:text/csv;charset=utf-8," +
      headers.join(",") +
      "\n" +
      rows.map((e) => e.join(",")).join("\n");
    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "attendance.csv");
    link.innerHTML = "Click Here to download";
    document.body.appendChild(link); // Required for FF
    link.click();

    // Revoke the object URL to free up memory resources.
    URL.revokeObjectURL(link.href);
    toast.push("Downloaded Spreadsheet!", {
      theme: {
        "--toastColor": "mintcream",
        "--toastBackground": "rgba(72,187,120,0.9)",
        "--toastBarBackground": "#2F855A",
      },
      duration: 1000,
    });
  };

  const deleteuser = (prn) => {
    studs = studs.filter((s) => s !== prn);
  };
</script>

<svelte:head>
  <title>Barcode Attendance System</title>
</svelte:head>
<main>
  <SvelteToast />

  <TailwindCss />
  <div
    class="flex h-auto min-h-screen w-auto flex-col items-center justify-center bg-gray-900 py-10"
  >
    <div class="py-10 text-3xl text-white font-bold font-mono">
      Attendance System
    </div>
    <form class="w-full max-w-lg" method="POST" id="form" on:submit={onSub}>
      <div class="py-3" />
      <div class="-mx-3 mb-6 flex flex-wrap">
        <div class="w-full px-3">
          <label
            class="mb-2 block text-xs font-bold uppercase tracking-wide text-gray-700"
            for="full-name"
          >
            PRN:
          </label>
          <input
            required
            class="block w-full appearance-none rounded border border-none bg-gray-800 px-4 py-3 leading-tight text-white focus:border-gray-500 focus:bg-gray-700 focus:outline-none"
            id="full-name"
            minlength="3"
            type="number"
            placeholder=""
            autofocus={true}
            bind:this={prn}
            disabled={false}
            name="prn"
          />
        </div>
      </div>
    </form>
    <br />
    <div class="flex flex-col">
      <div class="-m-1.5 overflow-x-auto">
        <div class="p-1.5 min-w-full inline-block align-middle">
          <div class="overflow-hidden">
            <table
              class="min-w-full divide-y divide-gray-200 dark:divide-gray-700"
            >
              <thead>
                <tr>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase"
                    >PRN</th
                  >
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase"
                    >Name</th
                  >
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase"
                    >Roll No.</th
                  >
                  <th
                    scope="col"
                    class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase"
                    >Action</th
                  >
                </tr>
              </thead>
              <tbody>
                {#each studs as stud_prn}
                  <tr
                    class="odd:bg-white even:bg-gray-100 dark:odd:bg-slate-900 dark:even:bg-slate-800"
                  >
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800 dark:text-gray-200"
                      >{stud_prn}</td
                    >
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200"
                      >{data[stud_prn].name}</td
                    >
                    <td
                      class="px-6 py-4 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200"
                      >{data[stud_prn].roll_no}</td
                    >
                    <td
                      class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
                    >
                      <div
                        class="text-red-500 hover:red-blue-700 cursor-pointer"
                        on:click={() => deleteuser(stud_prn)}
                      >
                        Delete
                      </div>
                    </td>
                  </tr>
                {/each}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div />
    <br />
    <button
      class="bg-cyan-600 hover:bg-cyan-900 font-bold py-2 px-4 rounded inline-flex items-center border-0 pd"
      on:click={jsonToCsv}
    >
      <svg
        class="w-4 h-4 mr-2 fill-white"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        ><path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" /></svg
      >
      <span>Download Spreadsheet</span>
    </button>
    <div class="has-tooltip my-10 bg-yellow-700 rounded p-2 hover:bg-yellow-800">
      <span
        class="tooltip rounded shadow-lg bg-slate-600 text-white-500 -mt-8 text-left font-mono p-2 "
      >
        This software was made for Physics Project for Topic "Decoding the
        Science behind Barcodes" by

        <ul>
          <li>Yashraj Narke</li>
          <li>Stavan Mistry</li>
          <li>Ayush Devdhe</li>
          <li>Sanyam Sharma</li>
          <li>Nitin Srivastav</li>
        </ul>
      </span>
      Hover me :)
    </div>
  </div>
</main>
